
<div class="val-barre-progression">
  <kendo-progressbar [min]="0"
                     [max]="etendu"
                     [value]="position"
                     [label]="labelSettings">
  </kendo-progressbar>
</div>

